import { render, staticRenderFns } from "./issueCardLegacy.vue?vue&type=template&id=3b38d087&scoped=true&"
import script from "./issueCardLegacy.vue?vue&type=script&lang=ts&"
export * from "./issueCardLegacy.vue?vue&type=script&lang=ts&"
import style0 from "./issueCardLegacy.vue?vue&type=style&index=0&id=3b38d087&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b38d087",
  null
  
)

export default component.exports